<template>
    <div class="lms__superadmin_users_bulk_actions_add_to_groups_select_groups">
        <form-select
            :class="'lms__superadmin_users_bulk_actions_add_to_groups_select_groups_form'"
            :data-vv-as="'groups'"
            :get-items-getter="'getLmsSuperadminGroupsMappedIdName'"
            :get-items-getter-mapped="'getLmsSuperadminGroupsMappedLabelValue'"
            :get-items-dispatch="'lmsSuperadminGroupsGet'"
            :get-items-dispatch-data="loggedInWorkspaceId"
            :search-queryable="false"
            :table-labels="[
                {
                    key: 'name',
                    title: 'Name',
                    type: 'string',
                    sortable: true,
                    queryable: true
                }
            ]"
            :item-name="['group', 'groups']"
            :label="'Select groups to add users to'"
            :multiple="true"
            :name="`lms-superadmin-users-bulk-actions-add-to-groups-select-groups`"
            :value="selectedGroups"
            :pop-table-filter-empty-state-title="'There are no groups in this workspace.'"
            @input="setSelectedGroups"
            @input-table="setSelectedGroups"
        ></form-select>
    </div>
</template>

<script>
import LmsSuperadminUsersBulkActionsAddToGroupsSelectUsersTable from '@/components/lms/superadmin/users/bulk/actions/addtogroups/LmsSuperadminUsersBulkActionsAddToGroupsSelectUsersTable'
import FormSelect from '@/components/default/forms/FormSelect'

export default {
  name: 'lms-superadmin-users-bulk-actions-add-to-groups-select-groups',
  components: { FormSelect },
  data () {
    return {
      LmsSuperadminUsersBulkActionsAddToGroupsSelectUsersTable
    }
  },
  computed: {
    loggedInWorkspaceId () {
      return this.$store.getters.getAuthUserSecondStageTokenDataWorkspaceId
    },
    selectedGroups () {
      return this.$store.getters.getLmsSuperadminUsersBulkActionsAddToGroupsGroups
    },
    usersCheckedProfileIds () {
      return this.$store.getters.getLmsSuperadminUsersBulkActionsAddToGroupsUsersCheckedProfileIds
    }
  },
  methods: {
    setSelectedGroups (data) {
      this.$store.dispatch('lmsSuperadminUsersBulkActionsAddToGroupsSetGroups', data)
    },
    checkIfHasUsersChecked () {
      const usersCheckedProfileIds = this.usersCheckedProfileIds

      if (!usersCheckedProfileIds || !usersCheckedProfileIds.length) {
        this.$router.push({ name: 'lms-superadmin-user-bulk-actions-add-to-groups-select-users' })
      }
    }
  },
  mounted () {
    this.checkIfHasUsersChecked()
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/lms/superadmin/users/_lmssuperadminusersbulkactionsaddtogroupsselectgroups.scss";
</style>
